<!-- Step.vue  -->
<template>
  <div class="stepOut">
    <ul>
      <li class="stepItem" v-for="(stepItem, index) in stepInfo" :key="index">
       <div class="stepItem-top">
          <!-- 模拟步骤条的节点，此处为圆圈 -->
          <div class="icon"></div>
          <!-- 模拟步骤条连接线，动态显示  -->
          <div class="line" v-if="index!=stepInfo.length-1"></div>
           <!-- 步骤名称  -->
          <div class="stepText">{{stepItem.status}}</div>
          <div @click="setStepList(index)" class="gobtn" v-if="index!=stepInfo.length-1&&!stepItem.hiddenLink">点击前往></div>
       </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'steps',
  props: {
    // 传递步骤参数
    stepInfo: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    setStepList(index) {
      this.$emit('setStepList', index)
    },
  },
}
</script>

<style lang="less" scoped>
.stepOut {
  width: 100%;
  // height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5F6670;
  .stepItem {
    height: 50px;
    font-size: 16px;
    text-align: left;
    position: relative;
    margin-bottom: 30px;
    &:last-child{
      margin-bottom: 10px;
    }
    &-top{
       position: relative;
       vertical-align: middle;
       div{
        display: inline-block;
       }
    }
    .icon {
      width: 20px;
      height: 20px;
      background: #336edc;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;
      z-index: 888;
      vertical-align: middle;
      transform: translateY(1px);
    }
    .line {
      position: absolute;
      top: 50px;
      left: 10px;
      height: 30px;
      width: 1px;
      margin-top: -10px;
      background: #C0C3C5;
      z-index: 111;
    }
    .stepText {
      line-height: 36px;
      font-size: 13px;
      letter-spacing: 0;
      font-weight: 500;
      vertical-align: middle;
      margin-left: 10px;
    }
  }
}
li{list-style-type:none;}
.gobtn{
  color: #276BEC;
  font-size: 12px;
  cursor: pointer;
  font-weight: bold;
  margin-left: 10px;
}
</style>
